import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { WebflowLoginPageRoutingModule } from './webflow-login-routing.module';

import { WebflowLoginPage } from './webflow-login.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, WebflowLoginPageRoutingModule, ComponentsModule, TextMaskModule],
  declarations: [WebflowLoginPage],
})
export class WebflowLoginPageModule {}
